// (A) 중립 Row API — antd 미접촉. (B) PlainRow 에 위임.
import type { CSSProperties, ReactNode } from 'react'
import { PlainRow } from '../_impl/PlainRow'

export interface OmwRowProps {
  className?: string
  style?: CSSProperties
  children?: ReactNode
  'data-testid'?: string
}

export function OmwRow(props: OmwRowProps) {
  return <PlainRow {...props} />
}
